import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    height: '2.5rem',
});

export const label: TRuleWithTheme = () => ({
    padding: '0 0.75rem',
});

export const deleteButton: TRuleWithTheme = ({ theme }) => ({
    '&.ant-btn-text': {
        height: '2.5rem',
        padding: '0 0.75rem',

        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '1.5rem',

        color: theme.colors.foregroundsDestructive,
    },
});

export const clearButton: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    width: '2rem',
    height: '2rem',
});
